export enum IntegrationType {
  Braze = `braze`,
  Marketo = `marketo`,
  UrbanAirship = `urbanairship`,
  FacebookAds = `facebookads`,
  GoogleAds = `googleads`,
  Iterable = `iterable`,
}

export enum ExportModalStep {
  History = 1,
  SelectType,
}

export enum ExportStatus {
  Created = 0,
  Started,
  Finished,
  Errored,
}
